module.exports = __webpack_public_path__ + "img/quick_02.e9af7b1d.png";